// SkillIndustryList.js

const SKILLS_BY_INDUSTRY = {
  "SAAS": {
    "default": ["check_pricing", "get_features", "schedule_demo", "get_support"],
    "CRM": { "extras": ["get_contacts", "create_deal"] },
    "HRTECH": { "extras": ["post_job", "track_applicant"] },
    "DEVTOOLS": { "extras": ["get_api_keys", "view_logs"] },
    "MARKETING_AUTOMATION": { "extras": ["create_campaign", "get_analytics"] },
    "ACCOUNTING_SOFTWARE": { "extras": ["create_invoice", "track_expense"] },
    "E_SIGNATURE": { "extras": ["send_contract", "get_signing_status"] },
    "AI_SOFTWARE": { "extras": ["call_inference", "list_models"] },
    "PROJECT_MANAGEMENT": { "extras": ["create_task", "get_timeline"] },
    "HELPDESK_SOFTWARE": { "extras": ["create_ticket", "search_kb"] },
    "CUSTOMER_SUPPORT_SOFTWARE": { "extras": ["start_chat", "resolve_ticket"] },
    "PRODUCTIVITY_SOFTWARE": { "extras": ["create_note", "set_reminder"] },
    "ANALYTICS_SOFTWARE": { "extras": ["run_query", "get_dashboard"] },
    "CYBERSECURITY_SOFTWARE": { "extras": ["scan_vulnerability", "get_incident_report"] },
    "FINTECH_SOFTWARE": { "extras": ["process_transaction", "get_balance"] },
    "HEALTHCARE_SOFTWARE": { "extras": ["get_patient_record", "schedule_appointment"] },
    "ERP_SOFTWARE": { "extras": ["check_inventory", "place_order"] },
    "NO_CODE_PLATFORM": { "extras": ["create_app", "publish_page"] },
    "API_PLATFORM": { "extras": ["get_endpoints", "view_usage"] },
  },
  "MEDIA": {
    "default": ["list_content", "subscribe", "get_schedule"],
    "STREAMING": { "extras": ["search_movie", "add_to_watchlist"] },
    "PODCASTING": { "extras": ["get_episodes", "follow_show"] },
    "DIGITAL_PUBLISHING": { "extras": ["read_article", "subscribe_newsletter"] },
    "NEWS": { "extras": ["get_headlines", "filter_by_category"] },
    "CREATOR_PLATFORM": { "extras": ["view_profile", "support_creator"] },
    "NEWSLETTER_PLATFORM": { "extras": ["manage_subscription", "view_archive"] },
    "YOUTUBE_CHANNEL": { "extras": ["search_video", "get_playlist"] },
    "MEDIA_NETWORK": { "extras": ["list_partners", "request_ad"] },
    "RADIO": { "extras": ["get_current_song", "request_track"] },
    "ENTERTAINMENT": { "extras": ["buy_ticket", "get_event_date"] },
    "BLOGGING_PLATFORM": { "extras": ["create_post", "add_comment"] },
  },
  "SECURITY": {
    "default": ["get_certifications", "report_threat"],
    "HOME_SECURITY": { "extras": ["arm_system", "view_cameras"] },
    "CYBERSECURITY": { "extras": ["run_scan", "get_firewall_status"] },
    "IDENTITY_VERIFICATION": { "extras": ["verify_user", "submit_document"] },
    "BIOMETRICS": { "extras": ["enroll_fingerprint", "verify_face"] },
    "SURVEILLANCE": { "extras": ["get_feed", "search_recordings"] },
    "ACCESS_CONTROL": { "extras": ["grant_access", "revoke_card"] },
    "SMART_HOME_SECURITY": { "extras": ["lock_door", "get_sensor_status"] },
    "CCTV_INSTALLATION": { "extras": ["request_quote", "schedule_install"] },
    "NETWORK_SECURITY": { "extras": ["get_vpn_status", "check_ids_alert"] },
  },
  "RETAIL": {
    "default": ["search_product", "check_shipping", "get_return_policy"],
    "ELECTRONICS_RETAIL": { "extras": ["compare_models", "get_warranty"] },
    "FASHION_RETAIL": { "extras": ["get_size_chart", "check_availability"] },
    "JEWELRY": { "extras": ["request_certificate", "get_cleaning_guide"] },
    "FURNITURE": { "extras": ["get_assembly_video", "request_sample"] },
    "AUTOMOBILE_DEALERSHIP": { "extras": ["schedule_test_drive", "book_service"] },
    "GROCERY": { "extras": ["add_to_cart", "get_nutrition"] },
    "BEAUTY_RETAIL": { "extras": ["find_ingredients", "get_usage_tips"] },
    "LUXURY_RETAIL": { "extras": ["verify_authenticity", "request_catalog"] },
    "SPORTS_RETAIL": { "extras": ["get_sizing", "find_store_event"] },
    "BOOKSTORE": { "extras": ["search_book", "preorder"] },
    "PET_STORE": { "extras": ["get_breed_info", "check_toy_reviews"] },
    "MOBILE_STORE": { "extras": ["compare_specs", "trade_in"] },
    "HOME_DECOR": { "extras": ["get_room_ideas", "check_material_swatch"] },
  },
  "APPAREL": {
    "default": ["search_product", "get_size_guide", "check_returns"],
    "ACTIVEWEAR": { "extras": ["get_fabric_info", "check_care_instructions"] },
    "ETHNIC_WEAR": { "extras": ["book_tailor", "get_fabric_sample"] },
    "LUXURY_FASHION": { "extras": ["verify_authenticity", "request_closet"] },
    "STREETWEAR": { "extras": ["check_limited_drop", "reserve_item"] },
    "CUSTOM_CLOTHING": { "extras": ["schedule_measurement", "get_design_consultation"] },
    "FOOTWEAR": { "extras": ["get_size_conversion", "check_cushioning"] },
    "ACCESSORIES": { "extras": ["get_matching_items"] },
    "KIDS_WEAR": { "extras": ["get_safety_standards", "growth_chart"] },
    "MENS_FASHION": { "extras": ["get_style_guide", "fit_tips"] },
    "WOMENS_FASHION": { "extras": ["get_trends", "size_chart"] },
    "UNIFORMS": { "extras": ["order_custom_logo", "get_fabric_specs"] },
  },
  "MORTGAGE": {
    "default": ["check_rates", "calculate_payment", "check_eligibility"],
    "HOME_LOANS": { "extras": ["estimate_down_payment", "get_first_time_buyer_guide"] },
    "REFINANCING": { "extras": ["compare_savings", "get_closing_costs"] },
    "MORTGAGE_LENDING": { "extras": ["upload_document", "check_underwriting"] },
    "LOAN_BROKER": { "extras": ["compare_lenders", "get_pre_approval"] },
    "REAL_ESTATE_FINANCING": { "extras": ["get_bridge_loan_terms"] },
    "PROPERTY_LOANS": { "extras": ["check_commercial_rates"] },
  },
  "MARKETPLACE": {
    "default": ["list_categories", "search_listings", "get_seller_info"],
    "SERVICE_MARKETPLACE": { "extras": ["post_request", "book_service"] },
    "B2B_MARKETPLACE": { "extras": ["place_bulk_order", "request_quote"] },
    "FREELANCER_PLATFORM": { "extras": ["post_job", "hire_freelancer"] },
    "DIRECTORY_PLATFORM": { "extras": ["add_business", "write_review"] },
    "ECOMMERCE_MARKETPLACE": { "extras": ["track_order", "process_refund"] },
    "DIGITAL_PRODUCTS_MARKETPLACE": { "extras": ["download_file", "get_license"] },
    "JOB_MARKETPLACE": { "extras": ["search_jobs", "apply_now"] },
    "LOCAL_SERVICES_PLATFORM": { "extras": ["check_availability", "book_appointment"] },
  },
  "HOSPITALITY": {
    "default": ["check_availability", "get_rates", "book_room", "view_amenities","schedule_demo"],
    "HOTEL": { "extras": ["request_early_checkin", "order_room_service"] },
    "RESORT": { "extras": ["book_activity", "get_spa_menu"] },
    "VACATION_RENTAL": { "extras": ["check_house_rules", "get_checkin_instructions"] },
    "RESTAURANT": { "extras": ["view_menu", "make_reservation"] },
    "CAFE": { "extras": ["order_coffee", "check_wifi"] },
    "CLOUD_KITCHEN": { "extras": ["place_delivery_order", "track_delivery"] },
    "TRAVEL_AGENCY": { "extras": ["get_package", "book_flight"] },
    "TOUR_OPERATOR": { "extras": ["get_tour_schedule", "book_tour"] },
    "EVENT_VENUE": { "extras": ["check_hall_availability", "get_catering_menu"] },
    "BANQUET_HALL": { "extras": ["get_capacity", "view_decor_packages"] },
  },
  "REAL_ESTATE": {
    "default": ["search_properties", "get_neighborhood_info", "calculate_mortgage"],
    "PROPERTY_DEALER": { "extras": ["list_property", "schedule_viewing"] },
    "PROPERTY_MANAGEMENT": { "extras": ["submit_maintenance", "pay_rent"] },
    "COMMERCIAL_REAL_ESTATE": { "extras": ["search_office_space", "get_lease_terms"] },
    "REAL_ESTATE_CONSULTING": { "extras": ["get_valuation", "investment_advice"] },
    "INTERIOR_DESIGN": { "extras": ["view_portfolio", "request_consultation"] },
    "ARCHITECTURE": { "extras": ["view_blueprints", "get_project_timeline"] },
    "HOME_RENOVATION": { "extras": ["get_quote", "schedule_visit"] },
    "MODULAR_KITCHEN": { "extras": ["design_kitchen", "get_installation_date"] },
    "CONSTRUCTION": { "extras": ["get_material_quote", "track_project_status"] },
    "COWORKING_SPACE": { "extras": ["view_membership", "book_desk"] },
  },
  "EDTECH": {
    "default": ["list_courses", "get_syllabus", "view_instructors"],
    "ONLINE_COURSES": { "extras": ["watch_lecture", "get_certificate"] },
    "TEST_PREP": { "extras": ["take_practice_test", "get_score_report"] },
    "STUDY_ABROAD": { "extras": ["search_universities", "get_visa_requirements"] },
    "COACHING_INSTITUTE": { "extras": ["view_batch_schedule", "pay_fees"] },
    "LANGUAGE_LEARNING": { "extras": ["start_lesson", "get_vocabulary_list"] },
    "SKILL_DEVELOPMENT": { "extras": ["view_projects", "get_certification_path"] },
    "CODING_BOOTCAMP": { "extras": ["get_curriculum", "apply_admission"] },
    "TUTORING": { "extras": ["find_tutor", "schedule_session"] },
    "CAREER_TRAINING": { "extras": ["resume_review", "practice_interview"] },
  },
  "HEALTH_AND_WELLNESS": {
    "default": ["find_location", "view_practitioners", "book_appointment"],
    "FITNESS_CENTER": { "extras": ["view_equipment", "join_class"] },
    "YOGA_STUDIO": { "extras": ["get_class_types", "book_spot"] },
    "SALON": { "extras": ["view_services", "book_service"] },
    "COSMETIC_CLINIC": { "extras": ["list_procedures", "request_consultation"] },
    "DENTAL_CLINIC": { "extras": ["book_cleaning", "view_treatments"] },
    "SPA": { "extras": ["get_packages", "book_therapy"] },
    "SKIN_CLINIC": { "extras": ["view_skin_treatments", "order_products"] },
    "NUTRITION": { "extras": ["get_meal_plan", "book_consultation"] },
    "PERSONAL_TRAINING": { "extras": ["view_plans", "book_session"] },
    "WELLNESS_CENTER": { "extras": ["view_wellness_programs", "register_workshop"] },
  },
  "PROFESSIONAL_SERVICES": {
    "default": ["view_case_studies", "meet_team", "request_quote"],
    "LAW_FIRM": { "extras": ["check_practice_areas", "schedule_consultation"] },
    "ACCOUNTING_FIRM": { "extras": ["file_tax", "request_audit"] },
    "RECRUITMENT_AGENCY": { "extras": ["post_job", "search_candidates"] },
    "MARKETING_AGENCY": { "extras": ["view_services", "get_portfolio"] },
    "SOFTWARE_AGENCY": { "extras": ["get_tech_stack", "request_development_estimate"] },
    "CONSULTING": { "extras": ["get_expertise", "book_strategy_session"] },
    "TAX_CONSULTING": { "extras": ["file_return", "get_planning_advice"] },
    "HR_CONSULTING": { "extras": ["get_policy_template", "performance_review_guide"] },
    "BUSINESS_CONSULTING": { "extras": ["get_growth_strategy"] },
    "DESIGN_AGENCY": { "extras": ["view_portfolio", "request_branding_quote"] },
    "SEO_AGENCY": { "extras": ["get_seo_audit", "view_case_study"] },
    "DIGITAL_MARKETING_AGENCY": { "extras": ["request_campaign_quote", "get_analytics_report"] },
  },
  "FINTECH": {
    "default": ["get_security_info", "read_api_docs", "check_trust_certifications"],
    "PAYMENTS": { "extras": ["process_payment", "get_gateway_status"] },
    "ACCOUNTING": { "extras": ["get_balance_sheet", "generate_invoice"] },
    "WEALTHTECH": { "extras": ["view_portfolio", "get_robo_advice"] },
    "PERSONAL_FINANCE": { "extras": ["create_budget", "get_credit_score"] },
    "EXPENSE_MANAGEMENT": { "extras": ["scan_receipt", "submit_approval"] },
    "INVOICING": { "extras": ["send_invoice", "view_payment_history"] },
    "LENDING_PLATFORM": { "extras": ["apply_loan", "check_rate"] },
    "NEOBANK": { "extras": ["open_account", "block_card"] },
    "INVESTMENT_PLATFORM": { "extras": ["buy_stock", "get_market_data"] },
  },
  "AUTOMOTIVE": {
    "default": ["view_inventory", "find_service_center", "get_financing_options"],
    "CAR_DEALERSHIP": { "extras": ["search_new_cars", "schedule_test_drive"] },
    "BIKE_DEALERSHIP": { "extras": ["view_bike_models", "check_accessories"] },
    "CAR_RENTAL": { "extras": ["check_rates", "make_reservation"] },
    "AUTO_SERVICE": { "extras": ["book_service", "request_tow"] },
    "EV_CHARGING": { "extras": ["find_charger", "get_membership"] },
    "USED_CARS": { "extras": ["get_certified_list", "view_vehicle_history"] },
  },
  "HOME_SERVICES": {
    "default": ["check_service_area", "read_reviews", "get_quote"],
    "PLUMBING": { "extras": ["request_emergency", "schedule_repair"] },
    "ELECTRICAL_SERVICES": { "extras": ["schedule_installation"] },
    "HVAC": { "extras": ["book_ac_repair", "schedule_maintenance"] },
    "PEST_CONTROL": { "extras": ["identify_pest", "get_treatment_plan"] },
    "CLEANING_SERVICES": { "extras": ["select_package", "book_cleaning"] },
    "PACKERS_AND_MOVERS": { "extras": ["get_moving_quote", "order_packing_materials"] },
    "APPLIANCE_REPAIR": { "extras": ["schedule_repair"] },
  },
  "EVENTS_AND_WEDDINGS": {
    "default": ["view_portfolio", "get_packages", "request_quote"],
    "WEDDING_PLANNER": { "extras": ["get_vendor_list", "set_timeline"] },
    "EVENT_MANAGEMENT": { "extras": ["plan_corporate_event"] },
    "PHOTOGRAPHY": { "extras": ["view_gallery", "book_photoshoot"] },
    "VIDEOGRAPHY": { "extras": ["view_samples", "request_editing"] },
    "CATERING": { "extras": ["view_menu", "book_catering"] },
    "DECORATION_SERVICES": { "extras": ["select_theme", "confirm_setup"] },
  },
};


export default SKILLS_BY_INDUSTRY;